/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {get} from '@ion/core/src/environment/environment';
import {translate} from '@ion/core/src/locale/locale';
import {HelpCenterIcon} from '../../icons/HelpCenterIcon';
import {dlsColor, dlsTypography} from '../../theme/theme';

export interface HelpCenterButtonProps {
  elementId: string;
  resourceCenterMenu: boolean;
}

const useStyles = makeStyles((theme) => ({
  helpButtonContainer : {
    display         : 'flex',
    justifyContent  : 'center',
    alignItems      : 'center',
    cursor          : 'pointer',
    borderRadius    : '4px',
    padding         : '8px',
    border          : 'none',
    backgroundColor : 'transparent',
    '&:hover'       : {
      backgroundColor : dlsColor('paleBlue')
    }
  },
  helpButtonLabel : {
    ...dlsTypography('body1'),
    marginLeft : '4px',
    cursor     : 'pointer'
  }
}));
/**
 * The HelpCenterButton is used to display the Pendo Help Center.
 *
 * ```typescript
 *
 *   import {HelpCenterButton} from '../../components/buttons/';
 *
 *   <HelpCenterButton />
 *
 * ```
 */

export const HelpCenterButton = ({
  elementId,
  resourceCenterMenu = false
}: HelpCenterButtonProps) => {
  const classes = useStyles();

  const openHelpCenter = useCallback(() => {
    if (!resourceCenterMenu) {
      window.open(get('helpDocumentURL'), '_blank');
    }
  }, [resourceCenterMenu]);

  return (
    <button id={elementId} className={classes.helpButtonContainer} onClick={openHelpCenter}>
      <HelpCenterIcon elementId={elementId}/>
      <label className={classes.helpButtonLabel}>
        {translate('nav:ionprime.help')}
      </label>
    </button>
  );
};
